import React, { Component} from "react";
import Popup from "react-popup";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import { trackPromise } from "react-promise-tracker";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import PinVirtualService from '../../../../services/autogestion/pinVirtualService';
import history from "../../login/history";
import ConfigService from "../../../../services/configuracion/ConfigService";
import Loader from 'react-loader-spinner';
import { infonetUrl } from "../../../generico/utils/UrlAPI";

export default class Paso1 extends Component {
  origen = sessionStorage.getItem("ORIGEN");
  segundoPaso = sessionStorage.getItem("PASO2");
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso2 = React.createRef();
    this.paso2.current = false;
    this.paso3 = React.createRef();
    this.paso3.current = false;
    this.receiveMessageFromIframe = this.receiveMessageFromIframe.bind(this);
  }

  getInitialState = () => ({

    url:infonetUrl,
    estadoTarjeta:undefined,
    buscando : false,
    tokenPinPad:undefined,
    tokenConsulta:undefined,
  });

  actualizarPin(_action,_tokenPinpad){
    let data = {
      pan : sessionStorage.getItem('numeroTC'),
      tokenPinpad : _tokenPinpad,
      action:_action
    }
    if( sessionStorage.getItem('PARAMETRO') ){
      trackPromise(
        PinVirtualService.actualizarPin(data)
        .then( response => {
          if( response.data.datos?.success === 'true' ){
            this.props.goToStep(3);
          }else{
            Popup.queue(this.notifiPopup("Error", response.data.datos.message));
          }
        })
        .catch( err =>{
          console.log(err);
        })
      );
    }else{
      Popup.queue(this.notifiPopup("Error", 'Parametro no encontrado'));
    }
  }

  componentDidMount(){
    this.initData();
    if( sessionStorage.getItem('ACTION') === 'CREAR' ){
      //SI ES PASO 1
      if( !sessionStorage.getItem('PASO2') ){ 
        this.obtenerTokenAndEstadoTarjeta();
        // let estado = this.obtenerEstadoTarjeta();
        // if( estado ){
        //   this.obtenerTokenPinpad();
        // }else{
        //   return ;
        // }
      }else{ //ULTIMO PASO
        let tokenPinpad = sessionStorage.getItem('PARAMETRO');
        this.actualizarPin('R',tokenPinpad);
        // this.props.goToStep(3);
      }
    } else
    if( sessionStorage.getItem('ACTION') === 'MODIFICAR' ){
      //PASO1
      if( !sessionStorage.getItem('PASO2') && !sessionStorage.getItem('PASO3') ){
        this.obtenerTokenAndEstadoTarjeta();
      }else if( sessionStorage.getItem('PASO2') === 'true' ){
        //SEGUNDO PASO
        if( !sessionStorage.getItem('PASO3') ){
          this.props.goToStep(2);
        }else{
          //TERCER PASO
          let tokenPinpad = sessionStorage.getItem('PARAMETRO2');
          this.actualizarPin('M',tokenPinpad);
          // this.props.goToStep(3);
        }
      }
    }
    window.addEventListener('message',this.receiveMessageFromIframe);
  }

  obtenerToken(){
    this.setState({buscando:true});
    let data = {
      pan : sessionStorage.getItem('numeroTC')
    }
    trackPromise(
      PinVirtualService.obtenerToken(data)
      .then( response =>{
        if( response.data.datos === null ){
          // this.setState({buscando:false});
          Popup.queue(this.notifiPopup('Error',response.data.mensaje));
          return null;
        }
        if( response.data.datos.success === 'true' ){
          this.setState({buscando:false});
          return(response.data.datos.token);
        }else{
          Popup.queue(this.notifiPopup('Error','Error al obtener token'));
          this.setState({buscando:false});
          return null;
        }
      })
      .catch( err =>{
        this.setState({buscando:false});
        Popup.queue(this.notifiPopup('Error','Error al obtener token: '+err));
        return null;
      })
    )
  }

  obtenerTokenPinpad(){
    let token = this.obtenerToken();
    if( token !== null || token !== undefined ){
      this.setState({url:this.state.url + token , buscando : false});
    }else{
      // Popup.queue(this.notifiPopup("Error", 'Error al obtener url token pinpad'));
      this.returnHome();
    }
  }

  obtenerTokenAndEstadoTarjeta(){
    this.setState({buscando : true});
    let data = {
      pan : sessionStorage.getItem('numeroTC')
    }
    trackPromise(
      PinVirtualService.obtenerToken(data)
      .then( response => {
        if( response.data.datos === null ){
          this.setState({buscando:false});
          Popup.queue(this.notifiPopup("Error", response.data.mensaje));
        }
        if( response.data.datos.success === 'true' ){
          let data2 = {
            pan:sessionStorage.getItem('numeroTC'),
            token:response.data.datos.token
          }
          PinVirtualService.validarEstadoTarjeta(data2)
          .then( resp => {
            if( resp.data.codigo !== 0 ){
              if( resp.data.datos === null ){
                Popup.queue(this.notifiPopup('Error',resp.data.mensaje));
                this.setState({buscando:false});
              }else{
                Popup.queue(this.notifiPopup('Error',resp.data.datos.message));
                this.setState({buscando:false});
              }
            }
          })
          .catch( err =>{
            this.setState({buscando:false});
            Popup.queue(this.notifiPopup("Error", err));
          })
        }else{
          this.setState({buscando:false});
          Popup.queue(this.notifiPopup("Error", response.data.mensaje));
          // return null;
        }
      })
      .catch( err => {
        this.setState({buscando:false});
        Popup.queue(this.notifiPopup("Error", err));
      })
    );

    trackPromise(
      PinVirtualService.obtenerToken(data)
      .then( response =>{
        if( response.data.datos === null ){
          Popup.queue(this.notifiPopup("Error", response.data.mensaje));
        }
        if( response.data.datos.success === 'true' ){
          this.setState({url:this.state.url + response.data.datos.token , buscando : false});
        }
      })
      .catch( err => {
        Popup.queue(this.notifiPopup("Error", err));
      })
    );
  }

  componentWillUnmount(){
    window.removeEventListener('message',this.receiveMessageFromIframe);
  }

  receiveMessageFromIframe(event){
    if( event.origin !== sessionStorage.getItem('ORIGIN') ){
      
      if( sessionStorage.getItem('PASO2') === 'true' ){
        sessionStorage.setItem('PASO3','true');
      }

      if( !sessionStorage.getItem('PASO2') ){
        
        sessionStorage.setItem('PASO2','true');
      }

      if( event.data.data === undefined ){
        if( sessionStorage.getItem('PASO2') === 'true' && sessionStorage.getItem('PASO3') === 'true' ){
          sessionStorage.setItem('PARAMETRO2',event.data);
        }else{
          sessionStorage.setItem('PARAMETRO',event.data);
        }
      }
      history.push(ConfigService.getPathByName('crearPinVirtual')?.url);
      window.location.reload();
    }
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
              history.push(ConfigService.getPathByName("resumenGeneralSocio").url);
              window.location.reload();
            },
            // action : this.returnHome()
          },
        ],
      },
    });
  
  resetState = () => {
    this.setState(this.getInitialState());
  };

  initData = () => {
    this.resetState();
  };
  

  returnHome = (e) =>{
    history.push(ConfigService.getPathByName("resumenGeneralSocio").url);
    window.location.reload();
  }

  render() {
    if( this.props.currentStep !== 1 ){
      return null;
    }

    if( this.state.buscando  ){
      return (<Loader type="TailSpin" color="#007c34" height="100" width="100" />)
    }

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
          {
                sessionStorage.getItem('ACTION') === 'CREAR' ? 
                (
                  <ul role="tablist">
                    <li role="tab" className="current">
                      <span>
                        <div className="title">                
                          <span className="title_text">Nuevo Pin</span>
                        </div>
                      </span>
                    </li>

                    <li role="tab" className="disabled last">
                      <span>
                        <div className="title">
                          <span className="title_text">Confirmación</span>
                        </div>
                      </span>
                    </li>
                  </ul>
                )
                :
                (
                  <div>
                    <ul role="tablist">
                      <li role="tab" className="current">
                        <span>
                          <div className="title">                
                            <span className="title_text">Pin Actual</span>
                          </div>
                        </span>
                      </li>

                      <li role="tab" className="disabled">
                        <span>
                          <div className="title">
                            <span className="title_text">Nuevo Pin</span>
                          </div>
                        </span>
                      </li>

                      <li role="tab" className="disabled last">
                        <span>
                          <div className="title">
                            <span className="title_text">Confirmación</span>
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                )
              }
            {/* <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">                
                    <span className="title_text">Nuevo Pin</span>
                  </div>
                </span>
              </li>

              <li role="tab" className="disabled last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span> 
              </li>
            </ul> */}
          </div>
        </div>
          <section className="content">
              <div className="col-md-12 col-lg-12">
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    {
                      sessionStorage.getItem('ACTION') === 'CREAR' ? 
                      (
                        <h4 style={{color: '#1A9185', margin:"1rem"}}>Crear PIN</h4>
                      )
                      :
                      (
                        <h4 style={{color: '#1A9185', margin:"1rem"}}>Ingrese su PIN Actual</h4>
                      )
                    }
                    {/* <h4 style={{color: '#1A9185', margin:"1rem"}}>Cambio de PIN Tarjetas</h4> */}
                    <div className="callout callout-warning consideraciones" style={{lineHeight:"1.8rem"}}>
                      <h5>Consideraciones</h5>
                      <p>Recuerde que su PIN es exclusivamente para su uso personal y que sustituye a su firma, siendo de su entera responsabilidad el uso del mismo. No lo divulgue ni lo escriba. No elija un PIN que sea fácil de deducir por terceros (ej. año nacimiento). La Universitaria Ltda. se exime de toda responsabilidad y/o reclamo que pudiera surgir eventualmente por las operaciones realizadas a través de su PIN.</p>
                    </div>
                  </div>
                  <div className="col-md-12 d-flex my-2 justify-content-center">
                    {/* {this.mostrarPinPad()} */}
                    <div class='pinpad' onChange={this.onClickPinpad}>
                      <iframe title="PinPad" frameBorder='0'
                        width='332.5px'
                        height='338.55px'
                        src={this.state.url}>
                      </iframe>
                    </div>
                  </div>

                </div>
              </div>
          </section>

        <hr />

        <div className="row">
          <div className="col-lg-10 col-md-8">
            <div className="row">
              <label
                className="input-label-bold-obligatorio">
                (*) Campos Obligatorios
                <br />
              </label>
            </div>
          </div>
          {/* <div className="col-lg-2 col-md-4"> */}
          <div className="col-md-12 btn-consulta">
            <button 
              className="btn btn-cu-secundary" 
              onClick={this.returnHome}
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Volver al Inicio
            </button>
          </div> 
              {/* <button
                disabled={this.state.disableSgte}
                className="btn btn-cu-primary"
                onClick={(e) => {
                  this.nextStep.click();
                }}
              >
                Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button> */}
              {/* <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button> */}
            
          </div>
        {/* </div> */}

      </div>
    );
  }
}
